<template>
  <ul class="unitselect">
    <Checkbox
      v-for="(xx, index) in units"
      @on-change="unitChange(xx, index)"
      :key="index"
      v-model="xx.select"
      >{{ xx.name }}</Checkbox
    >
    <!--  <li
      v-for="(xx, index) in units"
      @click="unitChange(xx, index)"
      :key="index"
      :class="{ active: xx.select }"
    >
      {{ xx.name }}
    </li> -->
  </ul>
</template>
<script>
export default {
  props: ["unit","units"],
  data() {
    return {
      
    };
  },
  methods: {
    unitChange(xx, index) {
      var num = 0;
      for (let i = 0; i < this.units.length; i++) {
        if (this.units[i].select) {
          num += 1;
        }
      }
      if (num == 0) {
        this.$Message.error("至少保留一个计价单位");
        setTimeout(() => {
          this.units[index].select = true;
        }, 200);

        return;
      }
      // xx.select = !xx.select;
      this.$emit("on-change", {
        select: xx.select,
        name: xx.name,
        index: index,
      });
    },
    ff() {
      for (let i = 0; i < this.units.length; i++) {
        this.units[i].select = false;
        for (let j = 0; j < this.unit.length; j++) {
          if (this.unit[j] == this.units[i].name) {
            this.units[i].select = true;
          }
        }
      }
    },
  },
  mounted() {
    this.ff();
  },
  watch: {
    unit(v) {
      //console.log(v);
      this.ff();
    },
  },
};
</script>
<style>
.unitselect {
  display: flex;
}
.unitselect li {
  padding: 2px 10px;
  border: solid 2px #ccc;
}
.unitselect li.active {
  border: solid 2px #fb2020;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/baojia/unitBox.vue